import React from "react";
//Limitless imports
import { useAuthenticationContext } from "../../../expert";
import { fetchUserKnowledgeLibraries } from "../../apis/knowledge/KnowledgeAPI";
const INITIAL_LIBRARY_STATE = {
  loading: true,
  list: [],
  filteredList: [],
  publicLibraries: [],
  filterCharacters: ""
};
const UPDATE_LIBRARIES = "update-libraries";
const RESET_LIBRARIES = "reset-libraries";
const UPDATE_FILTER = "update-filter";
const libraryReducer = (state, action) => {
  switch (action.type) {
    case UPDATE_LIBRARIES:
      {
        const publicLibraries = action.payload.filter(kbItem => {
          return kbItem.kbType === "public";
        });
        return {
          ...state,
          filteredList: action.payload,
          list: action.payload,
          loading: false,
          publicLibraries
        };
      }
    case RESET_LIBRARIES:
      return INITIAL_LIBRARY_STATE;
    case UPDATE_FILTER:
      {
        const {
          filterCharacters
        } = action.payload;
        if (!filterCharacters) {
          return {
            ...state,
            filteredList: state.list,
            filterCharacters
          };
        }
        const filteredList = state.list.filter(listItem => {
          return listItem.displayName.toLowerCase().includes(filterCharacters.toLowerCase());
        });
        return {
          ...state,
          filteredList,
          filterCharacters
        };
      }
    default:
      throw new Error(`Unsupported library action type ${action.type}`);
  }
};
export const useKnowledgeLibraries = () => {
  const [libraries, dispatch] = React.useReducer(libraryReducer, INITIAL_LIBRARY_STATE);
  const {
    isAuthenticated
  } = useAuthenticationContext();
  React.useEffect(() => {
    if (isAuthenticated) {
      loadUserLibraries();
    } else {
      clearKnowledgeLibraries();
    }
  }, [isAuthenticated]);
  const loadUserLibraries = () => {
    fetchUserKnowledgeLibraries(result => {
      dispatch({
        type: UPDATE_LIBRARIES,
        payload: result
      });
    });
  };
  const updateLibraryFilter = filterCharacters => {
    dispatch({
      type: UPDATE_FILTER,
      payload: {
        filterCharacters
      }
    });
  };
  const clearKnowledgeLibraries = () => {
    dispatch({
      type: RESET_LIBRARIES
    });
  };
  return {
    libraries,
    updateLibraryFilter
  };
};